import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useAuth0 } from '@auth0/auth0-react';
import LoginAlert from './Login/LoginAlert';
import useGlobalStyles from '../css/GlobalStyles';
import { isAdminUser } from '../constants';

export default function AuthenticatedLayout({
    title,
    children,
    requireAdmin = false,
}) {
    const classes = useGlobalStyles();
    const { isAuthenticated, isLoading, user } = useAuth0();

    if (isLoading) {
        return (
            <div>
                <br /> &nbsp;Carregando dados ...
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <Grid container className={classes.root} alignItems="center" spacing={0}>
                <Card className={classes.cardLogin}>
                    <Paper className={classes.paper} elevation={5}>
                        <LoginAlert />
                    </Paper>
                </Card>
            </Grid>
        );
    }

    if (requireAdmin && !isAdminUser(user?.email)) {
        return (
            <Grid container className={classes.root} alignItems="center" spacing={0}>
                <Card className={classes.card}>
                    <Paper className={classes.paper} elevation={5}>
                        <Typography component="h4" variant="h5" align="center">
                            Acesso restrito a administradores.
                        </Typography>
                    </Paper>
                </Card>
            </Grid>
        );
    }

    return (
        <Grid container className={classes.root} alignItems="center" spacing={0}>
            <Card className={classes.card}>
                <Paper className={classes.paper} elevation={5}>
                    {title && (
                        <Typography
                            component="h4"
                            variant="h4"
                            align="center"
                            style={{ marginBottom: 50 }}
                        >
                            {title}
                        </Typography>
                    )}
                    {children}
                </Paper>
            </Card>
        </Grid>
    );
}
